import PostReviewModal from './PostReviewModal';

export default PostReviewModal;
